import { API_URL, getHeaders } from "../Config";
import { getRegId, getSyncMin } from "./regId";

function normalizeEndpoint(endpoint) {
  if (!endpoint) return "";

  if (endpoint.startsWith("http://") || endpoint.startsWith("https://")) {
    try {
      const url = new URL(endpoint);
      const path = url.pathname;

      const syncIndex = path.indexOf("/sincronizar/");
      if (syncIndex >= 0) {
        return path.substring(syncIndex);
      }

      return path;
    } catch {
      return endpoint;
    }
  }

  return endpoint;
}

function buildUrl(endpoint, params = {}) {
  const cleanBase = API_URL.endsWith("/") ? API_URL : `${API_URL}/`;
  const normalizedEndpoint = normalizeEndpoint(endpoint);
  const cleanEndpoint = normalizedEndpoint.startsWith("/")
    ? normalizedEndpoint.substring(1)
    : normalizedEndpoint;

  const queryParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      queryParams.set(key, value);
    }
  });

  const queryString = queryParams.toString();

  return `${cleanBase}${cleanEndpoint}${queryString ? `?${queryString}` : ""}`;
}

function parseXmlSyncIndex(xmlText) {
  const parser = new DOMParser();
  const xml = parser.parseFromString(xmlText, "application/xml");

  const serviciosNodes = Array.from(
    xml.getElementsByTagName("servicios"),
  ).filter((node) => node.getElementsByTagName("nombre").length > 0);

  const servicios = serviciosNodes.map((node) => ({
    nombre: node.getElementsByTagName("nombre")[0]?.textContent || "",
    descripcion: node.getElementsByTagName("descripcion")[0]?.textContent || "",
    endpoint: node.getElementsByTagName("endpoint")[0]?.textContent || "",
    min: Number(node.getElementsByTagName("min")[0]?.textContent || 0),
  }));

  return { servicios };
}

async function parseResponse(response) {
  const text = await response.text();

  if (!text) return null;

  const trimmed = text.trim();

  if (trimmed.startsWith("<")) {
    return parseXmlSyncIndex(trimmed);
  }

  try {
    return JSON.parse(trimmed);
  } catch {
    return trimmed;
  }
}

export async function getSyncIndex() {
  const response = await fetch(buildUrl("/sincronizar/index"), {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify({ regId: getRegId() }),
  });

  if (!response.ok) {
    throw new Error(`Error /sincronizar/index: ${response.status}`);
  }

  return parseResponse(response);
}

export async function getSyncResource(endpoint, min) {
  const response = await fetch(
    buildUrl(endpoint, {
      regId: getRegId(),
      min: getSyncMin(min),
    }),
    {
      method: "GET",
      headers: getHeaders(),
    },
  );

  if (!response.ok) {
    throw new Error(`Error ${endpoint}: ${response.status}`);
  }

  return parseResponse(response);
}
